import { Routes } from "@angular/router";
import { howItWorksRoutes } from "./how-it-works/how-it-works.routes";
import { ourWorkRoutes } from "./our-work/our-work.routes";
import { faqRoutes } from "./faq/faq.routes";
import { maintenanceGuard } from "../shared/guards/auth-guard.guard";
import { blogPostResolver } from "./blog/blog-post/blog-post.resolver";

export const pagesRoutes: Routes = [
  {
    path: 'pages',
    title: 'Pages',
    loadComponent: () => import('./pages.component').then(m => m.PagesComponent),
    canActivate: [maintenanceGuard],
    canActivateChild: [maintenanceGuard],
    children: [
      ...howItWorksRoutes,
      ...ourWorkRoutes,
      ...faqRoutes,
      {
        path: 'about-us',
        title: 'About us',
        loadComponent: () => import('./about-us/about-us-2/about-us-2.component').then(m => m.AboutUs2Component)
      },
      {
        path: 'our-team',
        title: 'Our Team',
        loadComponent: () => import('./about-us/our-team/our-team.component').then(m => m.OurTeamComponent)
      },
      {
        path: 'how-it-works',
        title: 'How It Works',
        loadComponent: () => import('./how-it-works-2/how-it-works-2.component').then(m => m.HowItWorks2Component)
      },
      {
        path: 'producers',
        title: 'Producers',
        loadComponent: () => import('./producers/producers.component').then(m => m.ProducersComponent)
      },
      {
        path: 'producers/:producerUrl',
        title: 'Producer Detail',
        loadComponent: () => import('./producers/producer-detail/producer-detail.component').then(m => m.ProducerDetailComponent)
      },
      {
        path: 'gift-cards',
        title: 'Gift cards',
        loadComponent: () => import('./gift-cards/gift-cards.component').then(m => m.GiftCardsComponent)
      },
      {
        path: 'contact-us',
        title: 'Contact Us',
        loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent)
      },
      {
        path: 'blog',
        title: 'Blog',
        loadComponent: () => import('./blog/blog.component').then(m => m.BlogComponent)
      },
      {
        path: 'blog-post/:category/:title',
        title: 'Blog Post',
        loadComponent: () => import('./blog/blog-post/blog-post.component').then(m => m.BlogPostComponent),
        resolve: { blogPost: blogPostResolver }
      },
    ]
  },
];
